<template>
  <div>
    首页
  </div>  
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/index/IndexVue.vue?00059acb